/*
  Keeps the cart offers bar in step with the cart.
  Kalles re-renders the mini cart on every change but copies back only a few fragments,
  so our bar would stay stale. On `cart:updated` we re-render sections/af-cart-tiers and
  swap every [data-af-cart-tiers] host. A failed fetch leaves the last render in place.
*/
(function () {
  if (window.__afCartTiers) return;
  window.__afCartTiers = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var timer = null;
  var inflight = null;

  function refresh() {
    if (!document.querySelector('[data-af-cart-tiers]')) return;
    if (inflight) inflight.abort();
    inflight = new AbortController();
    fetch(root + '?sections=af-cart-tiers', { signal: inflight.signal, headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data['af-cart-tiers']) return;
        var doc = new DOMParser().parseFromString(data['af-cart-tiers'], 'text/html');
        var fresh = doc.querySelector('[data-af-cart-tiers]');
        if (!fresh) return;
        document.querySelectorAll('[data-af-cart-tiers]').forEach(function (host) {
          host.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function (err) {
        if (err && err.name !== 'AbortError' && window.console) console.warn('[af-cart-tiers] refresh failed', err);
      });
  }

  document.addEventListener('cart:updated', function () {
    clearTimeout(timer);
    timer = setTimeout(refresh, 120);
  });
})();
